export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/playCircle.03b41e7b.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};